import { Client } from '../types';
import { ClientResponse } from '../types/dto/response/client-response.dto';
import { mapIntegrationsFromResponse } from './client-integration.mapper';
import { mapClientManagerFromResponse } from './client-manager.mapper';
import { mapClientPaymentTermsFromDTO } from './client-payment-terms.mapper';
import { mapClientStatusFromDTO } from './client-status.mapper';

export const mapClientFromClientResponse = (response: ClientResponse): Client => {
  return {
    id: response.id.toString(),
    name: response.name,
    logo: response.logoUrl ?? undefined,
    email: response.email,
    manager: response.manager ? mapClientManagerFromResponse(response.manager) : undefined,
    paymentTerms: mapClientPaymentTermsFromDTO(response.defaultPaymentTerms),
    billingAddress: response.billTo,
    shippingAddress: response.shipTo,
    status: mapClientStatusFromDTO(response.status),
    integrations: mapIntegrationsFromResponse(response.integrations.integrations),
    rawIntegrations: response.integrations.integrations,
  };
};
